import { render, staticRenderFns } from "./HotelOtherRoom.vue?vue&type=template&id=c42f378c&scoped=true&"
import script from "./HotelOtherRoom.vue?vue&type=script&lang=js&"
export * from "./HotelOtherRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42f378c",
  null
  
)

export default component.exports